// @flow

import React from 'react';
import { BrowserView } from 'react-device-detect';
import CardCompany from 'components/CardCompany';

type Props = {
  companies: Array<any>,
  user: any,
  isCurrentUser: boolean,
  handleLike: Function
};

export default ({ companies, user, isCurrentUser, handleLike }: Props) => (
  companies.length > 0 && <BrowserView renderWithFragment="true">
    <div className="row jobs-companies justify-content-center">
      {
        companies.map((company, index) => (
          <CardCompany
            key={company.id}
            user={user}
            isCurrentUser={isCurrentUser}
            handleLike={handleLike}
            company={company}
            trackEventName='view_search_company'
            classes={index === 2 ? 'col-12 col-md-6 d-lg-none d-xl-flex col-xl-4' : 'col-12 col-md-6 col-xl-4' }
          />
        ))
      }
    </div>
  </BrowserView>
);
